export const animateIn = (el, isAppearing, delay = 0) => {
  if (isAppearing) {
    return;
  }
  TweenMax.from(el, 0.6, {
    autoAlpha: 0,
    ease: Sine.easeOut,
    delay: delay
  });
};

export const animateOut = (el, animationTime = 0.4) => {
  TweenMax.to(el, animationTime, {
    autoAlpha: 0,
    ease: Sine.easeIn,
    overwrite: true
  });
};



// WEBPACK FOOTER //
// ./src/utils/transitions.js